const breakpointMixins = {
  computed: {
    isXsViewport() {
      return this.$vuetify.breakpoint.xs;
    },
    isSmViewport() {
      return this.$vuetify.breakpoint.sm;
    },
    isMdViewport() {
      return this.$vuetify.breakpoint.md;
    },
    isLgViewport() {
      return this.$vuetify.breakpoint.lg;
    },
    isXlViewport() {
      return this.$vuetify.breakpoint.xl;
    },
    isXsOnlyViewport() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isSmOnlyViewport() {
      return this.$vuetify.breakpoint.smOnly;
    },
    isSmAndDownViewport() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isSmAndUpViewport() {
      return this.$vuetify.breakpoint.smAndUp;
    },
    isMdOnlyViewport() {
      return this.$vuetify.breakpoint.mdOnly;
    },
    isMdAndDownViewport() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    isMdAndUpViewport() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    isLgOnlyViewport() {
      return this.$vuetify.breakpoint.lgOnly;
    },
    isLgAndDownViewport() {
      return this.$vuetify.breakpoint.lgAndDown;
    },
    isLgAndUpViewport() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    isXlOnlyViewport() {
      return this.$vuetify.breakpoint.xlOnly;
    }
  }
}

export default breakpointMixins